__turbopack_context__.v({
  "amenity-image": "theater-amenity-module-scss-module__GPIskW__amenity-image",
  "amenity-image-lg": "theater-amenity-module-scss-module__GPIskW__amenity-image-lg",
  "amenity-image-md": "theater-amenity-module-scss-module__GPIskW__amenity-image-md",
  "amenity-image-sm": "theater-amenity-module-scss-module__GPIskW__amenity-image-sm",
});
